import { render, staticRenderFns } from "./tabStarLevelEvaluate.vue?vue&type=template&id=2a308e45&"
import script from "./tabStarLevelEvaluate.vue?vue&type=script&lang=ts&"
export * from "./tabStarLevelEvaluate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports